import { useQuery } from "@tanstack/react-query";
import adminApiClient from "api/admin";

export const STUDIO_FAQ_QUERY_KEY = "studio-faq";

const useStudioFaq = () => {
  return useQuery({
    queryKey: [STUDIO_FAQ_QUERY_KEY],
    queryFn: () => adminApiClient.getStudioFaq(),
  });
};

export default useStudioFaq;
